/* tslint:disable */

declare var Object: any;
export interface SFOvertimeRequestSF6Interface {
  "id"?: number;
}

export class SFOvertimeRequestSF6 implements SFOvertimeRequestSF6Interface {
  "id": number;
  constructor(data?: SFOvertimeRequestSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOvertimeRequestSF6`.
   */
  public static getModelName() {
    return "SFOvertimeRequestSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOvertimeRequestSF6 for dynamic purposes.
  **/
  public static factory(data: SFOvertimeRequestSF6Interface): SFOvertimeRequestSF6{
    return new SFOvertimeRequestSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOvertimeRequestSF6',
      plural: 'SFOvertimeRequestSF6s',
      path: 'SFOvertimeRequestSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOvertimeRequestSF6.ts